import React from "react";

export const Children = props => <section {...props}>{props.children}</section>;